import Loading from "Components/Loading/Loading";
import UsersList from "Components/Users/UsersList";
import { useProjectUsers } from "features/users/hooks/userProjectUsers";
import UserPage from "Pages/Account/UserPage";
import { useCallback } from "react";
import { Route, Switch, useHistory } from "react-router-dom";

function UsersPage() {
  const { users, setUsers, loading } = useProjectUsers();
  const history = useHistory();

  const onNew = useCallback(() => {
    history.push(`./users/new`);
  }, [history]);

  const oEdit = useCallback(
    (user) => {
      history.push(`./users/${user.id}`);
    },
    [history]
  );

  if (loading) {
    return <Loading fullHeight />;
  }

  return (
    <Switch>
      <Route
        exact
        path="/clients/:clientId/projects/:projectId/account/users/:userId"
      >
        <UserPage isProject />
      </Route>
      <Route>
        <UsersList
          onEdit={oEdit}
          onNew={onNew}
          users={users}
          setUsers={setUsers}
          title="User Management"
        />
      </Route>
    </Switch>
  );
}

export default UsersPage;
